import {useContextSelector} from "use-context-selector";
import {useState} from "react";
import {AppCalendarContext} from "../../Providers";

export default function useAppCalendarSliderColor() {
    const sliderColor = useContextSelector(AppCalendarContext, ({ state }) => state.sliderColor)
    const updateState = useContextSelector(AppCalendarContext, ({ updateState }) => updateState)
    const [slider, setSlider] = useState({
        minWidth: sliderColor[0], maxWidth: sliderColor[1],
        value: sliderColor
    })

    return {
        min: -100,
        minLabel: 'Cheaper',
        max: 100,
        maxLabel: 'More expensive',
        value: sliderColor,
        onChange: value => updateState({ sliderColor: value }),
        slider, setSlider
    }
}